import React from 'react';

const ViewSubmittedSheets = () => {
    return (
        <div className="view-submitted-sheets-container">
            <div className="content-section">
            <h3 style={{ fontSize: "22px", fontWeight: "500", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
            Where can I find submitted timesheets?
                </h3>
               
                <p>Easily track and review submitted timesheets.</p>
                <p className="description">
                    This section helps you review and manage submitted timesheets efficiently.
                </p>

                <h4 className="section-heading">Step 1: Select a Timesheet</h4>
                <p>
                    Go to the "Submitted Sheets" section. Choose an employee's timesheet to review. You’ll see two options: <b>Approve</b> and <b>Reject</b>.
                </p>

                <h4 className="section-heading">Step 2: Approve the Timesheet</h4>
                <p> 
                    If the timesheet is correct, click "Approve" to confirm the recorded hours.
                </p>

                <h4 className="section-heading">Tip: Billable Hours</h4>
                <p> 
                    Approved timesheets will show billable hours for verification.
                </p>

                <h4 className="section-heading">Note: Email Notifications</h4>
                <p> 
                    Once approved, both you and the employee will receive a confirmation email.
                </p>

                <p className="closing-text">
                    Use this section for quick reference and follow-up actions.
                </p>

                <div className="image-container">
                    <img
                        className="placeholder-image"
                        src="https://res.cloudinary.com/danfpnuui/image/upload/v1737375336/Submitted_sheets_qdqx6t.png"
                        alt="Submitted Sheets Screenshot"
                    />
                </div>
            </div>

            <style jsx>{`
                .view-submitted-sheets-container {
                    padding: 15px;
                }

                .content-section {
                    max-width: 1100px;
                    margin: 0 auto;
                }

                .main-heading {
                    font-size: 22px;
                    font-weight: 400;
                    color: #000;
                    margin-bottom: 10px;
                }

                .section-heading {
                    font-size: 16px;
                    font-weight: 400;
                    color: #000;
                    margin-bottom: 8px;
                }

                .description, .closing-text {
                    font-size: 14px;
                    line-height: 1.5;
                    color: #4F4F4F;
                    margin-bottom: 15px;
                }

                .image-container {
                    display: flex;
                    justify-content: left;
                    margin-top: 15px;
                }

                .placeholder-image {
                    width: 75%; /* Medium image size */
                    height: auto;
                    max-width: 600px; /* Ensures image doesn't get too large */
                    border-radius: 5px;
                }

                @media (max-width: 768px) {
                    .main-heading {
                        font-size: 20px;
                    }

                    .section-heading {
                        font-size: 15px;
                    }

                    .description, .closing-text {
                        font-size: 13px;
                    }

                    .placeholder-image {
                        width: 80%;
                        max-width: 500px;
                    }
                }

                @media (max-width: 480px) {
                    .main-heading {
                        font-size: 18px;
                    }

                    .section-heading {
                        font-size: 14px;
                    }

                    .description, .closing-text {
                        font-size: 12px;
                    }

                    .placeholder-image {
                        width: 90%;
                        max-width: 450px;
                    }
                }
            `}</style>
        </div>
    );
};

export default ViewSubmittedSheets;
